export default () => ({
  content: {},
  mainConfig: null,
  engine: {}
})
